import { render, staticRenderFns } from "./messegeSend.vue?vue&type=template&id=3203f2f7"
import script from "./messegeSend.vue?vue&type=script&lang=ts"
export * from "./messegeSend.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports